import React from 'react';
import TabbedPage from '../../components/common/TabbedPage';
import Subscription from './Subscription';
import SubscriptionUsage from './SubscriptionUsage';
import BillingHistory from './BillingHistory';

// Account & Settings › Subscription — /settings/subscription?tab=plan|usage|billing
const SubscriptionTabs = ({ currentUser }) => (
  <TabbedPage tabs={[
    { key: 'plan', label: 'Plan', element: <Subscription currentUser={currentUser} /> },
    { key: 'usage', label: 'Usage & Limits', element: <SubscriptionUsage currentUser={currentUser} /> },
    { key: 'billing', label: 'Billing History', element: <BillingHistory currentUser={currentUser} /> },
  ]} />
);

export default SubscriptionTabs;
